import { HiOutlineArrowNarrowUp } from "react-icons/hi";
import { factor_convertor } from "../../../utils/Functions";

const TestRange = ({
  value,
  range,
  unit,
  status,
}: {
  value: number;
  range: any;
  unit: string;
  status: string;
}) => {
  const ranges = [
    { color: "bg-pr_test_high", label: "بالا" },
    // { color: "bg-pr_test_normal", label: "نرمال" },
    { color: "bg-pr_test_optimal", label: "نرمال" },
    // { color: "bg-pr_test_normal", label: "نرمال" },
    { color: "bg-pr_test_normal", label: "پایین" },
  ];

  return (
    <div className="relative w-full max-w-[500px] lg:w-[500px] rounded-full mt-10 flex gap-1">
      <div
        className="absolute z-10 top-0 bg-transparent h-[10px] w-[10px] rounded-full border-[2px] border-white"
        style={{
          left: `${factor_convertor(status).position}%`,
          transform: "translateX(-50%)",
        }}
      >
        <div className="absolute z-10 left-1 -bottom-[47px] -translate-x-1/2 text-red flex flex-col items-center">
          <HiOutlineArrowNarrowUp size={21} className="text-gray-800" />
          <p
            className="text-sm font-bold flex items-end"
            style={{ whiteSpace: "nowrap", direction: "ltr" }}
          >
            {value}{" "}
            <span
              className="font-light ml-1"
              style={{ fontSize: "11px", lineHeight: 1.5 }}
            >
              {unit}
            </span>
          </p>
        </div>
      </div>

      {ranges.map(({ color, label }, index) => (
        <div
          key={index}
          className={`relative z-0 ${color} flex-1 h-[10px] rounded-full`}
        >
          <span
            className="absolute -top-6 left-1/2 -translate-x-1/2 text-sm font-[900] font-rokh mt-[2px]"
            title={label}
          >
            {label}
          </span>
        </div>
      ))}
    </div>
  );
};

export default TestRange;
